import _extends from "@babel/runtime/helpers/extends";
import cn from 'classnames';
import { getElementStyles } from '../../themes/get-element-style';
export const pickStyle = (props, key, params = {
  className: '',
  style: {}
}) => {
  const {
    classNames,
    styles,
    styleSlots
  } = props;
  const k = key === 'root' ? 'base' : key;
  if (styleSlots != null && styleSlots[k]) {
    var _params$className, _params$style;
    return getElementStyles(k, styleSlots == null ? void 0 : styleSlots[k], {
      className: (_params$className = params.className) != null ? _params$className : '',
      style: (_params$style = params.style) != null ? _params$style : {}
    }, props);
  }
  return {
    className: cn(params == null ? void 0 : params.className, classNames == null ? void 0 : classNames[key]),
    style: _extends({}, params == null ? void 0 : params.style, styles == null ? void 0 : styles[key]),
    'data-style-layer': key
  };
};
export const extractLayer = (styles, layerName) => {
  if (!styles) {
    return {};
  }
  return Object.fromEntries(Object.entries(styles).filter(([key]) => key.match(`${layerName}_`)).map(([key, val]) => [key.split(`${layerName}_`)[1], val]));
};